// extracted by mini-css-extract-plugin
export default {"img":"Clipart_img__qNTJp"};